import { Component } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import * as page from '../../../pages/pages';

@Component({
	selector: 'page-case-studies',
	templateUrl: 'case-studies.html',
})

export class CaseStudiesPage {

	displayData: boolean = false;
	pageObj: any;
	listTitle: string;
	titleIcon: string;
	fileList: Array<{ client:string, filename: string, }>;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private file: File,
		private fileOpener: FileOpener,
		private platform: Platform,
		private iab: InAppBrowser
	) {
		this.pageObj = this.navParams.get('pageObj');
		console.log(this.pageObj);
	}

	ionViewDidLoad() {
		this.listTitle = this.pageObj.title;
		this.titleIcon = this.pageObj.icon;

		if (this.pageObj.pageName === 'elearning') {
			this.listTitle = 'eLearning';
			this.fileList = [
				{ client: 'Customer Service Professional', filename: 'Customer_Service_Professional' }
			];
		} else if(this.pageObj.pageName === 'eassessment'){
			this.listTitle = 'eAssessment';
			this.fileList = [
				{ client: 'Scottish Waterways Trust', filename: 'Scottish_Waterways_Trust' },
				{ client: 'IWCF', filename: 'IWCF' },
				{ client: 'The Chartered Banker Institute', filename: 'Chartered_Banker_Institute' },
				{ client: 'Scottish Joint Industry Board (SJIB)', filename: 'Scottish_Joint_Industry_Board' },
				{ client: 'NetRegs Assessment', filename: 'Netregs_Assessment' }
			];
		} else if(this.pageObj.pageName === 'badging'){
			this.listTitle = 'Badging';
			this.fileList = [
				{ client: 'Georgia Southern University', filename: 'Georgia_Southern_University' },
				{ client: 'The International Well Control Forum (IWCF)', filename: 'IWCF_Digital_Badging' },
			];
		} else if(this.pageObj.pageName === 'bespoke-elearning'){
			this.listTitle = 'Bespoke eLearning';
			this.fileList = [
				{ client: 'Aroma Academy', filename: 'Aroma_Academy' },
				{ client: 'Devro', filename: 'Devro' },
				{ client: 'Scottish Association for Mental Health', filename: 'Scottish_Association_for_Mental_Health' },
				{ client: 'Children\'s Health Scotland', filename: 'Childrens_Health_Scotland' },
				{ client: 'Corporate Parenting', filename: 'Corporate_Parenting' },
				{ client: 'NHS - District Nurse', filename: 'District_Nurse' },
				{ client: 'NHS - DP Asset', filename: 'DP_Asset' },
				{ client: 'Hyundai', filename: 'Hyundai' },
				{ client: 'Keep Scotland Beautiful', filename: 'Keep_Scotland_Beautiful' },
				{ client: 'Sportscotland', filename: 'SportScotland' },
				{ client: 'AFFIRM - The University of Edinburgh', filename: 'University_of_Edinburgh_AFFIRM' },
				{ client: 'NetRegs - Accessible eLearning', filename: 'Netregs_Accessible_eLearning' },
				{ client: 'RNIB', filename: 'RNIB' },
				{ client: 'CHS', filename: 'CHS' },
			];
		} else if(this.pageObj.pageName === 'consultancy'){
			this.listTitle = 'Consultancy';
			this.fileList = [
				{ client: 'Alzheimer Scotland', filename: 'Alzheimer_Scotland' }
			];
		} else if(this.pageObj.pageName === 'bespoke-development'){
			this.listTitle = 'Bespoke Development';
			this.fileList = [
				{ client: 'Aviagen', filename: 'Aviagen' },
				{ client: 'Global Oil & Chemicals Company', filename: 'Global_Oil_and_Chemicals_Company' },
				{ client: 'Howden', filename: 'Howden' },
				{ client: 'University of St Andrews', filename: 'StAN' },
				{ client: 'Operational Geoscience International Competency Assessment (OGICA)', filename: 'OGICA' }
			];
		}

		this.displayData = true;
	}


	openFile(file) {

		if(file.filename == null){
			this.navCtrl.push(page.CaseStudyPage, file);
		} else if(file.filename === 'Alzheimer_Scotland'){
			this.iab.create('https://www.ecomscotland.com/case-studies/alzheimer-scotland/', '_system');
		} else {
			let fullFileName = file.filename  + '.pdf';

			if(this.platform.is('ios')){
				console.log("Platform is iOS");
				this.file.checkFile(this.file.documentsDirectory, fullFileName).then((result: boolean) => {
	
					this.fileOpener.open(this.file.documentsDirectory + fullFileName, 'application/pdf').then( () => 
						console.log('File is opened')
					).catch( e => 
						console.log('Error openening file', e)
					);
	
				}).catch((err) => {
					this.file.copyFile(this.file.applicationDirectory + 'www/assets/case-studies/', fullFileName, this.file.documentsDirectory, fullFileName).then( result => {
						this.fileOpener.open(this.file.documentsDirectory + fullFileName, 'application/pdf').then( () => 
							console.log('File is opened')
						).catch( e => 
							console.log('Error openening file', e)
						);
					}, err => {
						console.log("Error");
						console.log(err);
					});
	
				});

			} 
		else if(this.platform.is('core')) 
		{
			console.log("Platform is Browser");
			window.open("assets/case-studies/" + fullFileName, '_blank');
		}			
		else if(this.platform.is('android')) {
				console.log("Platform is Android");
				window.open("assets/case-studies/" + fullFileName, '_blank');
		
				// this.file.checkFile(this.file.externalApplicationStorageDirectory, fullFileName).then((result: boolean) => {
	
				// 	this.fileOpener.open(this.file.externalApplicationStorageDirectory + fullFileName, 'application/pdf').then( () => 
				// 		console.log('File is opened')
				// 	).catch( e => 
				// 		console.log('Error openening file', e)
				// 	);
	
				// }).catch((err) => {
				// 	this.file.copyFile(this.file.applicationDirectory + 'www/assets/case-studies/', fullFileName, this.file.externalApplicationStorageDirectory, fullFileName).then( result => {
				// 		this.fileOpener.open(this.file.externalApplicationStorageDirectory + fullFileName, 'application/pdf').then( () => 
				// 			console.log('File is opened')
				// 		).catch( e => 
				// 			console.log('Error openening file', e)
				// 		);
				// 	}, err => {
				// 		console.log("Error");
				// 		console.log(err);
				// 	});
	
				// });
	
			} else {
				console.log(this.platform.platforms());
	
			}
	
		}
	}

	openFileInBrowser(filename){
		if(filename === 'Alzheimer_Scotland') {
			this.iab.create('https://www.ecomscotland.com/case-studies/alzheimer-scotland/', '_system');
		}
		else {
			this.iab.create('assets/case-studies/' + filename + '.pdf', '_system');
		}
	}

}



// WEBPACK FOOTER //
// ./src/pages/topics/case-studies/case-studies.ts